// src/router/index.js就是当前项目的路由模块
// 1 导入Vue 和VueRouter的包
import Vue from 'vue'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
return originalPush.call(this, location).catch(err => err)
}
// 导入路由要用到的组件
import Main from '../components/Main.vue'
import List from '../components/List.vue'
import Sandan from '../components/Sandan.vue'
import NewsList from '../components/NewsList.vue'
import Member from '../components/Member.vue'
import About from '../components/About.vue'
import Details from '../components/Details.vue'
import NewsDetails from '../components/NewsDetails.vue'
import Release from '../components/Release.vue'
import Register from '../components/Register.vue'
import UserCenter from '../components/UserCenter.vue'
import Myinfo from '../userpages/Myinfo.vue'
import Managezb from '../userpages/Managezb.vue'
import Pubzb from '../userpages/Pubzb.vue'
import Resetpwd from '../userpages/Resetpwd.vue'
import Jianjie from'../aboutpages/Jianjie.vue'
import Contact from'../aboutpages/Contact.vue'
import Paytype from'../aboutpages/Paytype.vue'
import Wzsm from'../aboutpages/Wzsm.vue'
import Search from'../components/Search.vue'
import Html from'../components/HtmlPanel.vue'
import Login from '../components/Login.vue'
// 2 调用vue.use()函数，把VueRouter安装为vue插件
Vue.use(VueRouter)


// 3 创建路由的实例对象
const router = new VueRouter({
  mode: 'history',
  // 定义数组routes[],对应哈希地址与组件之间的关系
  routes: [
  //路由规则
	{ 
		path: '/', 
		redirect:'/index',
	},
    { 
		path: '/list', 
		component: List,
		meta:{
			keepAlive:false
		}
		// name:'list' ,
	},
	{
		path: '/sandan', 
		component: Sandan,
		meta:{
			keepAlive:false
		}
		// name:'list' ,
	},
	{
		path: '/pay/html/:html?', 
		component: Html,
		name:'Html'
		// name:'list' ,
	},
	{
		path: '/newslist/id/:id', 
		component: NewsList,
		// name:'newslist' ,
	},
	{ 
		path: '/index', 
		component: Main,
		// name:'main',
	},
	{ 
		path: '/member', 
		component: Member,
		// name:'member',
	},
	{
		path: '/login', 
		component: Login,
		// name:'member',
	},
	{
		path: '/search/keywords/:keywords', 
		component: Search,
		// name:'member',
	},
	{ 
		path: '/about', 
		component: About,
		redirect:'about/jianjie',
		children:[
			{
				path:'jianjie',
				component:Jianjie
			},
			{
				path:'contact',
				component:Contact
			},
			{
				path:'paytype',
				component:Paytype
			},
			{
				path:'wzsm',
				component:Wzsm
			}
		]
		// name:'about',
	},
    { 
		path: '/details/id/:id', 
		component: Details,
		// name:'details' ,
	},
    { 
		path: '/newsdetails/id/:id', 
		component: NewsDetails,
		// name:'newsdetails' ,
	},
    { 
		path: '/release', 
		component: Release,
		// name:'release' ,
	},
    { 
		path: '/register', 
		component: Register,
		// name:'release' ,
	},
    { 
		path: '/usercenter', 
		component: UserCenter,
		redirect:'usercenter/myinfo',
		children:[
			{
				path:'myinfo',
				component:Myinfo
			},
			{
				path:'managezb',
				component:Managezb
			},
			{
				path:'pubzb',
				component:Release
			},
			{
				path:'resetpwd',
				component:Resetpwd
			}
		]
		// name:'release' ,
	}
	// { path: '/', component: Main, redirect:'/main', name:'main' }
  ]
})
// 4 向外共享路由的实例对象
export default router
